import { DropdownOption, DropdownSelector } from './DropdownSelector';

interface ContactSourceSelectorProps {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  error?: string;
  touched?: boolean;
  label?: string;
}

const contactSourceOptions: DropdownOption[] = [
  { value: 'AI Chatbot Search', label: 'AI Chatbot Search' },
  { value: 'Apple Podcast', label: 'Apple Podcast' },
  { value: 'Direct Mail', label: 'Direct Mail' },
  { value: 'Events', label: 'Event' },
  { value: 'Events - Eventbrite', label: 'Eventbrite' },
  { value: 'Facebook', label: 'Facebook' },
  { value: 'Google', label: 'Google' },
  { value: 'Instagram', label: 'Instagram' },
  { value: 'LinkedIn', label: 'LinkedIn' },
  { value: 'Events - Meetup', label: 'Meetup' },
  { value: 'Other', label: 'Other' },
  { value: 'Real Estate Sign', label: 'Real Estate Sign' },
  { value: 'referral', label: 'Referral' },
  { value: 'Spotify', label: 'Spotify Podcast' },
  { value: 'TikTok', label: 'TikTok' },
  { value: 'Yelp', label: 'Yelp' },
  { value: 'YouTube', label: 'YouTube' },
];

export const ContactSourceSelector = ({
  value,
  onChange,
  onBlur,
  error,
  touched,
  label = 'How did you hear about us?',
}: ContactSourceSelectorProps) => (
  <DropdownSelector
    options={contactSourceOptions}
    value={value}
    onChange={onChange}
    onBlur={onBlur}
    error={error}
    touched={touched}
    label={label}
  />
);
